import Tracked from 'editor/utils/Tracked';
import { ImageSourceRaw, RasterSource } from 'mapbox-gl';
import { v4 as uuidv4 } from 'uuid';

interface MapboxRasterSourceTracked extends Record<string, unknown> {
  source: ImageSourceRaw | RasterSource;
  coordinates: number[][];
  width: number;
  height: number;
}

class MapboxRasterSource extends Tracked<MapboxRasterSourceTracked> {
  id: string;

  added = false;

  updatedFields = new Set();

  constructor(
    source: ImageSourceRaw | RasterSource,
    width: number,
    height: number,
    coordinates: number[][]
  ) {
    super({ source, width, height, coordinates });
    this.id = uuidv4();

    this.tracked.source = source;
  }

  didUpdate(prop: string): void {
    this.updatedFields.add(prop);
  }

  getSource(): ImageSourceRaw | RasterSource {
    return this.tracked.source;
  }
}

export default MapboxRasterSource;
